module.exports = __webpack_public_path__ + "static/media/022.ff83011c.jpg";